import React, { Component } from 'react';
// import Raven from 'raven-js'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    // Raven.captureException(error, { extra: errorInfo })
  }
  render() {
    if (this.state.hasError) {
      return (
        <div id="error-wrapper">
          <h2>Oops.. Something went wrong. 😢</h2>
          <style jsx>{`
            #error-wrapper {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 75vh;
              background-color: grey;
              text-transform: uppercase;
              color: #FFF;
            }
          `}</style>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js